let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hbUTl")).then(() => parcelRequire('6MwDI'));